import React from "react"

function MarkdownParagraphComponent({
  children
}: React.HTMLProps<HTMLParagraphElement>) {
  return <p>{children}</p>
}

export const MarkdownParagraph = React.memo(
  MarkdownParagraphComponent
) as typeof MarkdownParagraphComponent
